import type { ModuleGridType } from 'types/studio/items'

import {
  buildVanDerValkPitchedRoofSlopeFromModuleGrid,
  computeVanDerValkRoofPolygonInclinationDeg,
  type VanDerValkBuildPitchedRoofSlopeErrorReason,
  VDV_MIN_ROOF_POLYGON_INCLINATION_DEG,
} from './buildVanDerValkPitchedRoofSlope'

/** Vendor minimum: pitched inclination must be > 5° (exclusive). */
export const VDV_PITCHED_INCLINATION_MIN_DEG = VDV_MIN_ROOF_POLYGON_INCLINATION_DEG

/** Maximum roof inclination (degrees) for pitched BOM. */
export const VDV_PITCHED_INCLINATION_MAX_DEG = 90

export function isVanDerValkPitchedInclinationValid(degrees: number): boolean {
  return (
    Number.isFinite(degrees) &&
    degrees > VDV_PITCHED_INCLINATION_MIN_DEG &&
    degrees <= VDV_PITCHED_INCLINATION_MAX_DEG
  )
}

export type DeriveVanDerValkPitchedInclinationFromModuleGridResult =
  | { ok: true; inclinationOverride: number }
  | { ok: false; reason: VanDerValkBuildPitchedRoofSlopeErrorReason }

/** Derives per-grid ``inclinationOverride`` from Quick Roof facet geometry. */
export function deriveVanDerValkPitchedInclinationOverrideFromModuleGrid(
  grid: ModuleGridType
): DeriveVanDerValkPitchedInclinationFromModuleGridResult {
  const roofSlopeBuilt = buildVanDerValkPitchedRoofSlopeFromModuleGrid(grid)
  if (!roofSlopeBuilt.ok) {
    return { ok: false, reason: roofSlopeBuilt.reason }
  }
  const inclination = computeVanDerValkRoofPolygonInclinationDeg(roofSlopeBuilt.roofSlope.roofPolygon)
  if (inclination == null || !isVanDerValkPitchedInclinationValid(inclination)) {
    return { ok: false, reason: 'roof_slope_too_shallow' }
  }
  return { ok: true, inclinationOverride: inclination }
}
